/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Show
 */
export interface Show {
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Show
     */
    deadlineDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    onText1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    onText2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    announcementLink?: string | null;
}

/**
 * Check if a given object implements the Show interface.
 */
export function instanceOfShow(value: object): value is Show {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ShowFromJSON(json: any): Show {
    return ShowFromJSONTyped(json, false);
}

export function ShowFromJSONTyped(json: any, ignoreDiscriminator: boolean): Show {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'deadlineDate': json['deadlineDate'] == null ? undefined : (new Date(json['deadlineDate'])),
        'location': json['location'] == null ? undefined : json['location'],
        'city': json['city'] == null ? undefined : json['city'],
        'onText1': json['onText1'] == null ? undefined : json['onText1'],
        'onText2': json['onText2'] == null ? undefined : json['onText2'],
        'announcementLink': json['announcementLink'] == null ? undefined : json['announcementLink'],
    };
}

export function ShowToJSON(json: any): Show {
    return ShowToJSONTyped(json, false);
}

export function ShowToJSONTyped(value?: Show | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'deadlineDate': value['deadlineDate'] == null ? undefined : ((value['deadlineDate']).toISOString().substring(0,10)),
        'location': value['location'],
        'city': value['city'],
        'onText1': value['onText1'],
        'onText2': value['onText2'],
        'announcementLink': value['announcementLink'],
    };
}

